import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { CartProvider } from '@/contexts/CartContext';
import { WishlistProvider } from '@/contexts/WishlistContext';
import { Toaster } from '@/components/ui/sonner';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import AuthCallback from '@/components/AuthCallback';
import Home from '@/pages/Home';
import Products from '@/pages/Products';
import ProductDetail from '@/pages/ProductDetail';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Cart from '@/pages/Cart';
import Checkout from '@/pages/Checkout';
import Profile from '@/pages/Profile';
import Wishlist from '@/pages/Wishlist';
import Wholesale from '@/pages/Wholesale';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminCustomerDetail from '@/pages/AdminCustomerDetail';
import AdminTools from '@/pages/AdminTools';
import AdminCMS from '@/pages/AdminCMS';
import AdminInventory from '@/pages/AdminInventory';
import ReturnPolicy from '@/pages/ReturnPolicy';
import BookCall from '@/pages/BookCall';
import MyBookings from '@/pages/MyBookings';
import '@/App.css';

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <div className="App min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/wholesale" element={<Wholesale />} />
          <Route path="/profile/*" element={<Profile />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/customers/:id" element={<AdminCustomerDetail />} />
          <Route path="/admin/tools" element={<AdminTools />} />
          <Route path="/admin/cms" element={<AdminCMS />} />
          <Route path="/admin/inventory" element={<AdminInventory />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/book-call" element={<BookCall />} />
          <Route path="/my-bookings" element={<MyBookings />} />
        </Routes>
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <WishlistProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </WishlistProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
